import React, { FC, useEffect } from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import { DragAndDropImgUpload } from 'src/components';
import { convertImageFileToBase64 } from 'src/utils';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { BundleDetailsV2 } from 'src/redux/slices/pc-bundles/types';
import useResolution from 'src/hooks/useResolution';

const {
  actions: pcBundleActions,
  selectors: pcBundleSelectors
} = slices.pcBundles;

interface Props {
  bundle?: BundleDetailsV2;
}

const component: FC<Props> = ({ bundle }) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useResolution();

  const banner = useAppSelector(pcBundleSelectors.selectBanner);

  const onChangeBanner = async (img: File[]) => {
    if (img && img.length > 0) {
      const firstFile = img[0];
      const result = await convertImageFileToBase64(firstFile);
      if (typeof result === 'string') {
        const base64Image = result;
        dispatch(pcBundleActions.setBanner(base64Image));
      } else {
        console.error('Base64 conversion did not return a string:', result);
      }
    }
  };

  useEffect(() => {
    if (bundle?.cover_url) {
      dispatch(pcBundleActions.setBanner(bundle?.cover_url));
    }
  }, [bundle, dispatch]);

  return (
    <Card style={{ marginTop: '1em' }}>
      <CardContent>
        <Typography>Bundle Banner</Typography>

        {banner && (
          <Box
            sx={{
              padding: '1rem',
              display: 'flex',
              justifyContent: 'center',
              p: '1rem'
            }}
          >
            <img
              alt="Cover Image"
              src={banner}
              style={{
                width: 900,
                height: isMobile ? 100 : 300,
                objectFit: 'contain'
              }}
            />
          </Box>
        )}

        <DragAndDropImgUpload
          title="Drag or select photo for Banner"
          onImageSelected={onChangeBanner}
        />
      </CardContent>
    </Card>
  );
};

export const AddBundleBanner = React.memo(component);
